// extracted by mini-css-extract-plugin
export var controls = "Pairings-module--controls--4X3U4";
export var title = "Pairings-module--title--xVCa0";
export var wrapper = "Pairings-module--wrapper--K+Zhk";